import type { KeyboardEvent } from 'react';

/**
 * Shared modal focus-trap helpers, extracted from ListVersionsDialog so other
 * dialogs (CaptureSheet) reuse the same trap instead of keeping copies.
 */

export const FOCUSABLE_SELECTOR =
  'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), ' +
  'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const FOCUS_RING_CLASSES =
  'focus-visible:[box-shadow:0_0_0_2px_var(--surface),0_0_0_4px_var(--ring)] focus-visible:outline-none';

/**
 * Wraps Tab/Shift+Tab inside `panel` (the `tabIndex={-1}` dialog panel).
 * Call from the panel's onKeyDown; keys other than Tab are ignored.
 */
export function trapTabKey(e: KeyboardEvent, panel: HTMLElement | null): void {
  if (e.key !== 'Tab' || !panel) return;
  const focusables = Array.from(panel.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
  if (focusables.length === 0) {
    e.preventDefault();
    return;
  }
  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  if (e.shiftKey) {
    if (document.activeElement === first || document.activeElement === panel) {
      e.preventDefault();
      last.focus();
    }
  } else if (document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}
